/**
*   Created by FANGlh on 2018/11/26 18:01.
*   Desc:
*/
import './ApprovelDetail.css';
import React,{Component} from 'react';
import hi2_img from '../../../style/imgs/ic_head2.png';
import line_img from '../../../style/imgs/line_img.png';

export default class ItemApprovel extends Component{
    constructor(props){
        super(props);
        this.state = {
            itemdata:this.props.itemdata
        }
    }
     render(){
        return(
            <div style={{marginLeft:20}}>
                <div className="timeList_sty">
                    <div style={{width:10,height:10,background:'#BDBDBD',borderRadius:'30px'}}></div>
                    <div style={{marginLeft:10,width:"62%"}}>
                        <div ><span style={{color:'#000000',fontSize:15}}>{this.props.itemdata.value }</span><span style={{color:'#666666',fontSize:12,marginLeft:10}}>{this.props.approveDate}</span></div>
                        {
                            this.props.approveStatus == 2 ?
                                <div style={{color:"#666666",fontSize:12,marginTop:5,wordWrap:'break-word'}}><span>{(this.props.suggest.value == null || this.props.suggest.value == undefined || this.props.suggest.value == '')?"(审批语:无)":"(审批语:"+this.props.suggest.value+")"}</span></div>
                                : ''
                        }
                    </div>
                    <div style={{fontSize:12,textAlign:'right'}} className={this.props.approveStatus == 1?'doing':'done'}>
                        {this.props.approveStatus == 1 ? '等待审批' : (this.props.approveStatus == 2 ? '已同意' : '已拒绝')}</div>
                </div>
            </div>
        )
    }

}